import { Injectable } from '@angular/core';
import { ToastrService, IndividualConfig } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class TfNotificationsService {

    constructor(
        private toastr: ToastrService
    ) {
    }

    showSuccess(message, title?, override?: Partial<IndividualConfig>) {
        this.toastr.success(message, title, override);
    }

    showSuccessHtml(message, title?, override?: Partial<IndividualConfig>) {
        this.toastr.success(message, title, this.addHtmlFlag(override));
    }

    showError(message, title?, override?: Partial<IndividualConfig>) {
        this.toastr.error(message, title, override);
    }

    showErrorHtml(message, title?, override?: Partial<IndividualConfig>) {
        this.toastr.error(message, title, this.addHtmlFlag(override));
    }

    showInfo(message, title?, override?: Partial<IndividualConfig>) {
        this.toastr.info(message, title, override);
    }

    showInfoHtml(message, title?, override?: Partial<IndividualConfig>) {
        this.toastr.info(message, title, this.addHtmlFlag(override));
    }

    showWarning(message, title?, override?: Partial<IndividualConfig>) {
        this.toastr.warning(message, title, override)
    }

    showWarningHtml(message, title?, override?: Partial<IndividualConfig>) {
        this.toastr.warning(message, title, this.addHtmlFlag(override));
    }

    clear() {
        this.toastr.clear();
    }

    private addHtmlFlag(override: Partial<IndividualConfig>) {

        if (!override) {
            return {enableHtml: true};
        } else {
            Object.assign(override, {enableHtml: true});
        }

        return override;

    }

}
